<template>
  <div
    class="w-full border-b border-grey-900/25 shadow-sm"
    :class="theme.classes"
  >
    <div class="container start flex items-stretch gap-4 pb-5 pt-4">
      <component :is="theme.icon" class="h-6 w-6 shrink-0" />
      <div class="flex w-full justify-between gap-6 max-sm:flex-col">
        <div>
          <div class="mb-2">
            <strong class="text-base font-semibold">
              {{ content.heading }}
            </strong>
          </div>
          <div class="text-base font-light" v-html="content.body"></div>
        </div>
        <NuxtLink
          v-if="content.link"
          :to="content.link.url"
          class="link inline-flex shrink-0 items-center gap-1.5"
        >
          {{ content.link.label }}
          <IconOpenNewWindow
            v-if="content.link.offPage"
            class="size-4 fill-current"
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  type: AlertTypes;
  content: {
    heading: string;
    body: string;
    link?: {
      url: string;
      label: string;
      offPage?: boolean;
    };
  };
}>();

type AlertTypes = "warning" | "fatal" | "success" | "info" | "promo";

const themeMap: Record<
  AlertTypes,
  {
    icon: Component | string;
    classes: string;
  }
> = {
  warning: {
    icon: resolveComponent("IconAlertWarning"),
    classes: "bg-lemon-50 fill-lemon-700",
  },
  fatal: {
    icon: resolveComponent("IconAlertFatal"),
    classes: "bg-rose-50 fill-rose-700",
  },
  success: {
    icon: resolveComponent("IconAlertSuccess"),
    classes: "bg-green-50 fill-green-700",
  },
  info: {
    icon: resolveComponent("IconAlertInfo"),
    classes: "bg-sky-50 fill-sky-700",
  },
  promo: {
    icon: resolveComponent("IconAlertPromo"),
    classes: "bg-jag-50 fill-jag-700",
  },
};

const theme = computed(() => themeMap[props.type]);
</script>
